import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/brain/organize')({}).lazy(() =>
  import('./organize.lazy').then((d) => d.Route),
);
